import * as React from 'react';
import Error from './Error';

function withNetworkDetector(ComposedComponent: any) {
    return class NetworkDetector extends React.Component<any, { isDisconnected: boolean }> {
        state = {
            isDisconnected: false
        };

        componentDidMount() {
            this.setState({ isDisconnected: !navigator.onLine });
            window.addEventListener('online', this.handleConnectionChange);
            window.addEventListener('offline', this.handleConnectionChange);
        }

        componentWillUnmount() {
            window.removeEventListener('online', this.handleConnectionChange);
            window.removeEventListener('offline', this.handleConnectionChange);
        }

        handleConnectionChange = () => {
            if (navigator.onLine) {
                const webPing = setInterval(() => {
                    fetch('/')
                        .then(() => {
                            this.setState({ isDisconnected: false }, () => {
                                window.location.reload();
                                clearInterval(webPing);
                            });
                        })
                        .catch(() => this.setState({ isDisconnected: true }));
                }, 2000);
                return;
            }

            this.setState({ isDisconnected: true });
        };

        render() {
            const { isDisconnected } = this.state;

            return (
                <div>
                    {isDisconnected && (
                        <Error
                            errorMessage="Internet connection lost. Trying to reconnect ..."
                            isopen={isDisconnected}
                            shouldAutoHide={false}
                            location={{ horizontal: 'center', vertical: 'top' }}
                        />
                    )}
                    <ComposedComponent {...this.props} />
                </div>
            );
        }
    };
}

export default withNetworkDetector;
